import { Col } from '../grid';
export default Col;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/col/index.js
// module id = 319
// module chunks = 0